import { ChainId } from '@pancakeswap-libs/sdk-v2'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x1b38EBAd553f218e2962Cb1C0539Abb5d6A37774', 
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
